module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/soluzioni_cloud_pagina-27cd894ce2ec77bddbcc1050bedbd5dc.png";